import React from "react";

import { formatNumber } from "utils";

import { Card, Col, MapInteractive } from "components";

export const UserReportedMap = ({ field, geometry, location, markers }) => (
  <>
    <Col sm={24} md={12}>
      <h4>User reported size</h4>
      <p>{formatNumber({ number: parseFloat(field.size), decimalPlaces: 4 })}ha</p>
      <Card className="map-card">
        <MapInteractive
          field={field}
          geometry={geometry}
          location={location}
          markers={markers.map((marker) => ({
            ...marker,
            size: "l",
          }))}
          scaleControl={true}
          zoomControl={true}
        />
      </Card>
    </Col>
  </>
);
